<ng-container *ngIf="useIcon === false && everythingOk" miqStopClick>
  <a
    [target]="targetAnchor"
    [class]="classes"
    [matTooltipDisabled]="!toolTipMessage"
    [matTooltip]="toolTipMessage"
    [routerLink]="internalParams"
    (click)="onNavigate()"
    miqStopClick
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="useIcon && everythingOk" miqStopClick>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <a
    [target]="targetAnchor"
    [class]="classes"
    [matTooltipDisabled]="!toolTipMessage"
    [matTooltip]="toolTipMessage"
    [matTooltipPosition]="toolTipPosition"
    [routerLink]="internalParams"
    [queryParams]="dataParams"
    (click)="onNavigate()"
    miqStopClick
  >
    <mat-icon class="icon" [svgIcon]="svgIconName"></mat-icon>
  </a>
</ng-container>

<ng-container *ngIf="everythingOk === false">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>

<ng-template #content><ng-content></ng-content></ng-template>
